import { Navbar } from "@/components/navbar";
import { PricingCard } from "@/components/pricing-card";
import { useAction } from "convex/react";
import { useEffect, useState } from "react";
import { api } from "../../../../convex/_generated/api";

export default function NotSubscribed() {
  const getProducts = useAction(api.subscriptionsActions.getProducts);
  const [products, setProducts] = useState<any>(null);

  useEffect(() => {
    // Use real Stripe API to get products
    const result = async () => {
      try {
        const products = await getProducts();
        if (products?.data) {
          setProducts(products.data);
        } else {
          // Fallback to mock data if API call fails
          setProducts([
            {
              id: "price_1OvXXXXXXXXXXXXXXXXXXXXX",
              product: "prod_XXXXXXXXXXXXXXXX",
              amount: 2999,
              currency: "usd",
              interval: "month",
            },
            {
              id: "price_1OvXXXXXXXXXXXXXXXXXXXXY",
              product: "prod_XXXXXXXXXXXXXXXY",
              amount: 29990,
              currency: "usd",
              interval: "year",
            },
          ]);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
        // Fallback to mock data
        setProducts([
          {
            id: "price_1OvXXXXXXXXXXXXXXXXXXXXX",
            product: "prod_XXXXXXXXXXXXXXXX",
            amount: 2999,
            currency: "usd",
            interval: "month",
          },
          {
            id: "price_1OvXXXXXXXXXXXXXXXXXXXXY",
            product: "prod_XXXXXXXXXXXXXXXY",
            amount: 29990,
            currency: "usd",
            interval: "year",
          },
        ]);
      }
    };
    result();
  }, [getProducts]);

  if (!products) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center">
          <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-indigo-600" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Upgrade Your Account
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Get access to all features by subscribing to one of our plans
          </p>
        </div>

        <div className="mt-12 flex justify-center">
          <div className="grid max-w-7xl grid-cols-1 gap-6 sm:grid-cols-2">
            {products?.map((plan: any) => (
              <PricingCard
                key={plan.id}
                price={{
                  id: plan.id,
                  amount: plan.amount,
                  interval: plan.interval,
                  currency: plan.currency,
                }}
                product={{
                  id: plan.product,
                  name: plan.interval === "month" ? "Monthly Plan" : "Yearly Plan",
                  description: `${plan.currency.toUpperCase()} ${(plan.amount / 100).toFixed(2)}/${plan.interval}`,
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
